<template>
  <v-container class="pa-2">

    <v-row>
      <v-col class="ma-1 pa-0">

        <v-card class="pa-2 text-center" height="100%" width="100%" min-width="350">

          <v-card-text>
            <div class="text-h4 font-weight-thin d-flex justify-center">
              <span class="text-success">
                <CountUp :delay="countUp.delay" :endVal="screens.online" :options="countUp.options" />
              </span>
              <span>&nbsp;Screens Online</span>
            </div>
          </v-card-text>

          <v-card-text>
            <div class="text-h4 font-weight-thin d-flex justify-center">
              <span class="text-error">
                <CountUp :delay="countUp.delay" :endVal="screens.offline" :options="countUp.options" />
              </span>
              <span>&nbsp;Screens Offline</span>
            </div>
          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn variant="text" block>
              Go to Screen Settings
            </v-btn>
          </v-card-actions>

        </v-card>

      </v-col>
      <v-col class="ma-1 pa-0">

        <v-card class="pa-2 text-center" height="100%" width="100%" min-width="350">

          <v-card-text>
            <div class="text-h5 font-weight-thin d-flex justify-center">
              <span class="text-info">
                <CountUp :delay="countUp.delay" :endVal="screens.total" :options="countUp.options" />
              </span>
              <span>&nbsp;Screens</span>
            </div>
          </v-card-text>

          <v-card-text>
            <div class="text-h5 font-weight-thin d-flex justify-center">
              <span class="text-info">
                <CountUp :delay="countUp.delay" :endVal="files.total" :options="countUp.options" />
              </span>
              <span>&nbsp;Files</span>
            </div>
          </v-card-text>

          <v-card-text>
            <div class="text-h5 font-weight-thin">
              <span class="text-info">4</span> Sites
            </div>
          </v-card-text>

          <v-card-text>
            <div class="text-h5 font-weight-thin">
              <span class="text-info">9</span> Users
            </div>
          </v-card-text>

        </v-card>

      </v-col>
    </v-row>

    <v-row>
      <v-col class="ma-1 pa-0">

        <v-card class="pa-2 text-center" height="100%" width="100%" min-width="350">

          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline :model-value="value" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                stroke-linecap="round" smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-card-text>
            <div class="text-h4 font-weight-thin">
              Media Storage
            </div>
          </v-card-text>

        </v-card>

      </v-col>
      <v-col class="ma-1 pa-0">

        <v-card class="pa-2 text-center" height="100%" width="100%" min-width="350">

          <v-card-text>
            <v-sheet color="rgba(0, 0, 0, .12)">
              <v-sparkline :model-value="value" color="rgba(255, 255, 255, .7)" height="100" padding="24"
                stroke-linecap="round" smooth>
                <template v-slot:label="item">
                  ${{ item.value }}
                </template>
              </v-sparkline>
            </v-sheet>
          </v-card-text>

          <v-card-text>
            <div class="text-h4 font-weight-thin">
              Screen Activity
            </div>
          </v-card-text>

        </v-card>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import CountUp from 'vue-countup-v3';

import screenService from '@/services/Screen.service';
import FileService from '@/services/File.service';
//import siteService from '@/services/Site.service';

//import constants from '@/config/constants';

export default {
  name: 'DashboardView',
  data() {
    return {
      countUp: {
        options: {
          useEasing: true,
        },
        delay: 2,
      },
      screens: {
        offline: 0,
        online: 0,
        total: 0,
      },
      files: {
        total: 0,
      },
      value: [
        423,
        446,
        675,
        510,
        590,
        610,
        760,
      ],
    }
  },
  components: {
    CountUp,
  },
  inject: ['newAlert'],
  methods: {
    async getScreenCount() {

      const accessToken = await this.$auth0.getAccessTokenSilently();

      const { data, error } = await screenService.getCountInOrg(accessToken);

      if (data) {

        this.screens.offline = data.offline;
        this.screens.online = data.online;
        this.screens.total = data.total;
      }

      if (error) {
        this.newAlert(error.alert.type, error.alert.title, error.alert.text, error.status);

        this.objectListErrorMsg = error.alert.title;

        console.error(error);
      }
    },
    async getFileCount() {

      const accessToken = await this.$auth0.getAccessTokenSilently();

      const { data, error } = await FileService.getCountInOrg(accessToken);

      if (data) {

        this.files.total = data;
      }

      if (error) {
        this.newAlert(error.alert.type, error.alert.title, error.alert.text, error.status);

        this.objectListErrorMsg = error.alert.title;

        console.error(error);
      }
    },
  },
  async created() {
    await this.getScreenCount();
    await this.getFileCount();
  },
}
</script>
